import { UserFactory, Keys } from './CustomCategoryFactoryCreator';

// Return the base class as per keys value
export class CustomCategoryService {
  public static GetCusomCategoryByType(customCategoryType: number) {
    return UserFactory.GetCustomCategoryInstance(customCategoryType as Keys).GetValues(customCategoryType);
  }
}
